// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import { colors, fontSizes, layout, fontFamily, shadows } from '@/theme';
import Fetch from '@/utils/Fetch';
import Time from '@/utils/time';
import Helper from '@/utils/helper';
import * as Enums from '@/utils/enums';
import AppointmentDetail from '@/components/customer-zone/appointment/appointment-detail';
import MessagePost from '@/components/modals/message-post';
import ConfirmAction from '@/components/modals/confirm-action';
import PageContext from '@/utils/page-context';
import NoSSR from '@/utils/no-ssr'
import useMobileView from '@/hooks/useMobileView';
import LeadMessage from '@/components/customer-zone/general/lead-message';
import { useRouter } from 'next/router';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'

function ViewAppointment() {

  const pageContext = useContext(PageContext);
  const [mobileView] = useMobileView();

  const router = useRouter();
  const { t, c, i } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

  const { data: tenantData } = useQuery(
    ['czTenant', t],
    () => Fetch.preLogin({ tenantID: t }),
    { enabled: !!t }
  );
  const tenant = tenantData?.HttpStatusCode === 200 && tenantData.Results?.length > 0 ? tenantData.Results[0] : null;

  const { data: appointmentData } = useQuery(
    ['czAppointment', t, c, i],
    () => Fetch.get({
      url: `/CustomerZone/GetAppointment`,
      params: { appointmentID: i },
      tenantID: t,
      customerID: c,
      apiUrlOverride: tenant.API
    }),
    { enabled: !!tenant }
  );

  const [appointment, setAppointment] = useState<any>(null);

  useEffect(() => {
    if (tenantData && !tenant) {
      router.replace(`/customerzone/appointmentlist?t=${t}&c=${c}`);
    }
  }, [tenantData]);

  useEffect(() => {
    if (appointmentData && !appointment) {
      setAppointment(appointmentData);
      (pageContext as any).updateTenantName(appointmentData.headerTenantName);
    }
  }, [appointmentData]);

  const [showMessagePost, setShowMessagePost] = useState(false);
  const onMessagePost = (state: any) => {
    setShowMessagePost(false);
  };

  const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());

  if (!appointment || !tenant) return null;

  const primaryContact = appointment.Contact ? appointment.Contact : undefined;
  const appointmentLocation = appointment.Location ? appointment.Location : undefined;

  return (
    <NoSSR>
      <LeadMessage customerID={c} tenantID={t} page={"customerzone/viewappointment"} />
      <div className="row">
        <div className="column">
          <h3>{Time.dayOfWeek(appointment.StartDateTime)}, {Time.formatDate(appointment.StartDateTime)}</h3>
        </div>
        <div className="column-end">
          <div className="actions">
            <div title="Submit question or comment" className="message-button-container" onClick={() => setShowMessagePost(true)}>
              <img src={Enums.Icon.MessageCircle} alt="icon" className="icon" />
            </div>
            {showMessagePost ?
              <MessagePost
                onMessagePost={onMessagePost}
                module={Enums.Module.Appointment}
                itemID={appointment.ID}
                customerZone={true}
                tenantID={t}
                customerID={c}
                apiUrlOverride={tenant.API}
              /> : ''
            }
          </div>
        </div>
      </div>
      <div className="row">
        <div className="contact">
          {primaryContact ?
            <>
              <p className="contact-name">{primaryContact.FirstName + " " + primaryContact.LastName}</p>
              <p>{appointment.CustomerName}</p>
              <p>{primaryContact.MobileNumber}</p>
              <p>{primaryContact.EmailAddress}</p>
            </>
            : ""}
          <p>{appointmentLocation ? appointmentLocation.LocationDisplay : "No Location"}</p>
        </div>
      </div>

      <div className="card-container">
        <AppointmentDetail appointment={appointment} showPrint={false} tenantID={t} customerID={c} showTotals={false} showHyperlink={false}
          apiUrlOverride={tenant.API} mobileView={mobileView} />
      </div>

      <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions} />

      <style jsx>{`
        .card {
            background-color: ${colors.white};
            border-radius: ${layout.cardRadius};
            box-shadow: ${shadows.card};
            box-sizing: border-box;
            padding: 1rem 2rem;
            position: relative;
            width: 100%;
        }

        .card-container {
          margin-top: 0.5rem;
        }

        .card h3 {
            margin-top: 0;
        }

        .container {
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          padding: 1.5rem 3rem;
          overflow-x: hidden;
        }
          .row {
            display: flex;
          }
          .column {
            display: flex;
            flex-basis: 0;
            flex-direction: column;
            flex-grow: 1;
          }
          .column :global(.textarea-container) {
            height: 100%;
          }
          .column + .column {
            margin-left: 1.25rem;
          }
          .contact {
            width: 100%;
            padding-right: 16px;
          }

          .contact p {
            margin: 3px 0 0;
          }
          .contact p.contact-name {
            font-weight: bold;
          }
          .heading {
            color: ${colors.blueGrey};
            font-weight: bold;
          }
          .new-comment {
            position: relative;
          }
          .new-comment :global(.textarea-container){
            height: 5rem;
          }
          .new-comment img{
            cursor: pointer;
            position: absolute;
            right: 1rem;
            top: 1rem;
          }
          .loader {
            border-color: rgba(113, 143, 162, 0.2);
            border-left-color: ${colors.blueGrey};
            display: block;
            margin-bottom: 1rem;
            margin-top: 1rem;
          }
  
          .comment {
            background-color: ${colors.white};
            border-radius: ${layout.cardRadius};
            box-sizing: border-box;
            color: ${colors.blueGrey};
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-top: 0.5rem;
            padding: 1.25rem 1rem;
            position: relative;
            width: 100%;
          }
          .comment-info {
            align-items: center;
            display: flex;
            margin-bottom: 4px;
          }
          .job {
            color: ${colors.bluePrimary};
            font-weight: bold;
          }
          .name {
            color: ${colors.darkPrimary};
            font-weight: bold;
          }
          .time {
            color: ${colors.blueGrey};
            font-size: 12px;
            margin-left: 1rem;
          }
          .text {
            white-space: pre-wrap;
          }
          .edit {
            margin-top: 0.2rem;
            margin-left: 1rem;
          }
          .status {
            position: absolute;
            right: 0;
            top: 0;
            width: 20rem;
          }
          .status :global(.input-container){
            background-color: ${colors.bluePrimary};
          }
          .status :global(input){
            color: ${colors.white};
          }
          .status :global(label){
            color: ${colors.white};
            opacity: 0.8;
          }
          .actions {
            display: flex;
            flex-direction: row;
          }
          .action-button {
            margin-top: -1rem;
            margin-left: 0.5rem;
          }
          .message-button-container {
            align-items: center;
            border: 1px solid ${colors.blueGreyLight};
            border-radius: ${layout.cardRadius};
            box-sizing: border-box;
            cursor: pointer;
            display: flex;
            font-weight: bold;
            height: 2.5rem;
            justify-content: space-between;
            margin-top: 0.5rem;
            padding: 0.5rem 0.5rem 0.5rem 0.5rem;
            position: relative;
            margin-right: 0.5rem;
            margin-left: 0.5rem;
            background: ${colors.white};
          }
          .button-dropdown {
            width: 80px;
          }
       
      `}</style>
    </NoSSR>
  );
}

export default ViewAppointment;

export const Route = createFileRoute('/customerzone/viewappointment')({ component: ViewAppointment })
